// useBusquedaTurnos.js
import { useState } from 'react';
import { buscarTurnos } from '../../api/turnos';

// Encapsula la búsqueda de turnos: qué criterio se usó (nombre o servicio),
// el resultado, y sus estados de carga/error. El wizard (Buscar.jsx) solo
// necesita saber "en qué paso estoy", no cómo se piden los datos.
export function useBusquedaTurnos(pacienteId) {
  const [criterio, setCriterio] = useState(null); // { tipo, label, filtros }
  const [turnos, setTurnos] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');

  const buscar = async (filtros, label, tipo) => {
    setCriterio({ tipo, label, filtros });
    setCargando(true); setError(''); setTurnos([]);
    try {
      const data = await buscarTurnos({ pacienteId, ...filtros, pageSize: 100 });
      setTurnos(data.turnos || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setCargando(false);
    }
  };

  const reiniciar = () => {
    setCriterio(null); setTurnos([]); setError('');
  };

  const buscarPorMedico = (m) => buscar({ medicoId: m.id }, `${m.nombre} ${m.apellido}`, 'nombre');

  const buscarPorServicio = (s) => {
    const filtros = (s.tipo || '').toLowerCase() === 'practica'
      ? { practica: s.nombre }
      : { especialidad: s.nombre };
    buscar(filtros, s.nombre, 'servicio');
  };

  return { criterio, turnos, cargando, error, buscarPorMedico, buscarPorServicio, reiniciar };
}